import styles from "./Culture.module.scss";
import first from "../../Img/culture/first.png";
import second from "../../Img/culture/second.png";
import third from "../../Img/culture/third.png";
import fourth from "../../Img/culture/fourth.png";
import fifth from "../../Img/culture/fifth.png";
import classNames from "classnames";

export default function Culture({
  isDarkMode,
  width,
}: {
  isDarkMode: boolean;
  width: number;
}) {
  return (
    <div className={styles.culture_page}>
      <div className={!isDarkMode ? styles.container : styles.dark_container}>
        <div
          className={classNames(styles.topText, {
            "display-kr-L": width > 767 ? true : false,
            "title-kr-XL": width < 768 ? true : false,
          })}
        >
          일에만 집중할 수 있는 먼데이오프를 위해
        </div>
        <div className={styles.contentsContainer}>
          <div className={styles.contents_box}>
            <img src={first} alt="" />
            <div className={styles.contents}>
              <section className={styles.contents_title}>
                <p
                  className={classNames({
                    "display-kr-S": width > 1199 ? true : false,
                    "title-kr-XL": width < 1200 && width > 767 ? true : false,
                    "title-kr-L": width < 768 ? true : false,
                  })}
                >
                  최고의 컨디션을 낼 수 있도록, 최상의 근무환경을 제공합니다.
                </p>
              </section>
              <section className={styles.contents_context}>
                <div>
                  <p>•</p>
                  <p
                    className={classNames({
                      "label-kr-L": width > 767 ? true : false,
                      "body-kr-L": width < 768 ? true : false,
                    })}
                  >
                    유연근로제도
                  </p>
                </div>
                <div>
                  <p>•</p>
                  <p
                    className={classNames({
                      "label-kr-L": width > 767 ? true : false,
                      "body-kr-L": width < 768 ? true : false,
                    })}
                  >
                    리프레시 휴가 (프로젝트 마감 시 유급휴가 지원)
                  </p>
                </div>
                <div>
                  <p>•</p>
                  <p
                    className={classNames({
                      "label-kr-L": width > 767 ? true : false,
                      "body-kr-L": width < 768 ? true : false,
                    })}
                  >
                    초과근무 지양 (불가피한 초과근무 시 150% 초과 근무 수당
                    지급, 식대 별도 지원)
                  </p>
                </div>
                <div>
                  <p>•</p>
                  <p
                    className={classNames({
                      "label-kr-L": width > 767 ? true : false,
                      "body-kr-L": width < 768 ? true : false,
                    })}
                  >
                    주 35시간 근로
                  </p>
                </div>
              </section>
            </div>
          </div>
          <div className={styles.contents_box}>
            <img src={second} alt="" />
            <div className={styles.contents}>
              <section className={styles.contents_title}>
                <p
                  className={classNames({
                    "display-kr-S": width > 1199 ? true : false,
                    "title-kr-XL": width < 1200 && width > 767 ? true : false,
                    "title-kr-L": width < 768 ? true : false,
                  })}
                >
                  구성원의 건강을 생각합니다.
                </p>
              </section>
              <section className={styles.contents_context}>
                <div>
                  <p>•</p>
                  <p
                    className={classNames({
                      "label-kr-L": width > 767 ? true : false,
                      "body-kr-L": width < 768 ? true : false,
                    })}
                  >
                    30만원 이내의 건강검진 지원 (연1회)
                  </p>
                </div>
                <div>
                  <p>•</p>
                  <p
                    className={classNames({
                      "label-kr-L": width > 767 ? true : false,
                      "body-kr-L": width < 768 ? true : false,
                    })}
                  >
                    스낵바를 통한 건강한 간식 지원
                  </p>
                </div>
              </section>
            </div>
          </div>
          <div className={styles.contents_box}>
            <img src={third} alt="" />
            <div className={styles.contents}>
              <section className={styles.contents_title}>
                <p
                  className={classNames({
                    "display-kr-S": width > 1199 ? true : false,
                    "title-kr-XL": width < 1200 && width > 767 ? true : false,
                    "title-kr-L": width < 768 ? true : false,
                  })}
                >
                  업무가 항상 즐겁게 느껴지도록 노력합니다.
                </p>
              </section>
              <section className={styles.contents_context}>
                <div>
                  <p>•</p>
                  <p
                    className={classNames({
                      "label-kr-L": width > 767 ? true : false,
                      "body-kr-L": width < 768 ? true : false,
                    })}
                  >
                    월 1회 MondayOFF Day (매월 첫째 주 월요일 실시, 구성원간
                    자유로운 액티비티 진행)
                  </p>
                </div>
                <div>
                  <p>•</p>
                  <p
                    className={classNames({
                      "`label-kr-L`": width > 376 ? true : false,
                      "body-kr-L": width < 377 ? true : false,
                    })}
                  >
                    Studio팀 'Monday Run'{" "}
                    <div>(사내 게임잼, 연 1회 진행, 상금 지급)</div>
                  </p>
                </div>
                <div>
                  <p>•</p>
                  <p
                    className={classNames({
                      "label-kr-L": width > 767 ? true : false,
                      "body-kr-L": width < 768 ? true : false,
                    })}
                  >
                    크리스마스 파티 등 다양한 사내 행사 진행
                  </p>
                </div>
              </section>
            </div>
          </div>
          <div className={styles.contents_box}>
            <img src={fourth} alt="" />
            <div className={styles.contents}>
              <section className={styles.contents_title}>
                <p
                  className={classNames({
                    "display-kr-S": width > 1199 ? true : false,
                    "title-kr-XL": width < 1200 && width > 767 ? true : false,
                    "title-kr-L": width < 768 ? true : false,
                  })}
                >
                  구성원의 성장을 항상 우선순위로 생각합니다.
                </p>
              </section>
              <section className={styles.contents_context}>
                <div>
                  <p>•</p>
                  <p
                    className={classNames({
                      "label-kr-L": width > 767 ? true : false,
                      "body-kr-L": width < 768 ? true : false,
                    })}
                  >
                    효율적인 업무를 위한 Mac, 모니터 등 요청 기기 제공
                  </p>
                </div>
                <div>
                  <p>•</p>
                  <p
                    className={classNames({
                      "label-kr-L": width > 767 ? true : false,
                      "body-kr-L": width < 768 ? true : false,
                    })}
                  >
                    업무 관련 도서 상시 지원
                  </p>
                </div>
                <div>
                  <p>•</p>
                  <p
                    className={classNames({
                      "label-kr-L": width > 767 ? true : false,
                      "body-kr-L": width < 768 ? true : false,
                    })}
                  >
                    어학 교육 지원
                  </p>
                </div>
                <div>
                  <p>•</p>
                  <p
                    className={classNames({
                      "label-kr-L": width > 767 ? true : false,
                      "body-kr-L": width < 768 ? true : false,
                    })}
                  >
                    업무와 관련된 개인 학원비 지원{" "}
                  </p>
                </div>
              </section>
            </div>
          </div>
          <div className={styles.contents_box}>
            <img src={fifth} alt="" />
            <div className={styles.contents}>
              <section className={styles.contents_title}>
                <p
                  className={classNames({
                    "display-kr-S": width > 1199 ? true : false,
                    "title-kr-XL": width < 1200 && width > 767 ? true : false,
                    "title-kr-L": width < 768 ? true : false,
                  })}
                >
                  소중한 가족이 있기에, 우리가 있습니다.
                </p>
              </section>
              <section className={styles.contents_context}>
                <div>
                  <p>•</p>
                  <p
                    className={classNames({
                      "label-kr-L": width > 767 ? true : false,
                      "body-kr-L": width < 768 ? true : false,
                    })}
                  >
                    경조 휴가 및 경조금 지원
                  </p>
                </div>
                <div>
                  <p>•</p>
                  <p
                    className={classNames({
                      "label-kr-L": width > 767 ? true : false,
                      "body-kr-L": width < 768 ? true : false,
                    })}
                  >
                    상조 지원
                  </p>
                </div>
                <div>
                  <p>•</p>
                  <p
                    className={classNames({
                      "label-kr-L": width > 767 ? true : false,
                      "body-kr-L": width < 768 ? true : false,
                    })}
                  >
                    출산 축하지원금 지급
                  </p>
                </div>
                <div>
                  <p>•</p>
                  <p
                    className={classNames({
                      "label-kr-L": width > 767 ? true : false,
                      "body-kr-L": width < 768 ? true : false,
                    })}
                  >
                    자유로운 육아 휴가 및 출산 휴가
                  </p>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
